import {
  Warehouse, Package, Tag, Repeat, CircleDollarSign, FileText,
} from "lucide-react";
import { TabsList, TabsTrigger } from "../ui/tabs";
import { cn } from "@/lib/utils";

const TABS = [
  { value: "magazzino", label: "Magazzino", icon: Warehouse },
  { value: "consumi", label: "Consumi Extra", icon: Package },
  { value: "listino", label: "Listino", icon: Tag },
  { value: "ricorrenze", label: "Ricorrenze", icon: Repeat },
  { value: "spese", label: "Spese Extra", icon: CircleDollarSign },
  { value: "report", label: "Report", icon: FileText },
];

const triggerClass = cn(
  "flex-1 min-w-[7.5rem] flex items-center justify-center gap-2",
  "py-3.5 px-2 sm:px-4 rounded-none shadow-none",
  "bg-transparent text-slate-600 font-medium text-sm",
  "border-b-[3px] border-b-transparent -mb-px",
  "border-r border-r-slate-200 last:border-r-0",
  "transition-colors",
  "hover:text-slate-900 hover:bg-slate-50/80",
  "data-[state=active]:bg-transparent data-[state=active]:shadow-none",
  "data-[state=active]:text-rose-600 data-[state=active]:border-b-rose-600",
  "data-[state=active]:border-r-slate-200",
  "data-[state=active]:font-semibold",
  "[&_svg]:text-slate-500 [&[data-state=active]_svg]:text-rose-600",
  "focus-visible:ring-0 focus-visible:ring-offset-0",
);

export default function PrimaNotaSectionTabs() {
  return (
    <TabsList
      className={cn(
        "flex w-full h-auto p-0 mb-4",
        "bg-white rounded-xl border border-slate-200/90 shadow-sm",
        "overflow-x-auto overflow-y-hidden",
        "justify-stretch gap-0",
      )}
    >
      {TABS.map((t) => {
        const Icon = t.icon;
        return (
          <TabsTrigger key={t.value} value={t.value} className={triggerClass}>
            <Icon className="w-4 h-4 shrink-0" strokeWidth={2} />
            <span className="whitespace-nowrap">{t.label}</span>
          </TabsTrigger>
        );
      })}
    </TabsList>
  );
}
